import { defineAsyncComponent } from 'vue'
export default {
  principal: defineAsyncComponent(() => import("/opt/app-root/src/layouts/Principal.vue").then(m => m.default || m))
}